<script lang="ts">
    import { tick } from 'svelte'

    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'
    import { gettext as _ } from 'hydria/services/gettext'
    import { DateTime, toLuxon } from 'hydria/utils/time'

    import { d3, nv, nvReady } from 'wdom/utils/nvd'

    import type { IEntry } from './nsd_defs'

    interface Props {
        loading: boolean
        entries: IEntry[] | undefined
    }

    let { loading, entries }: Props = $props()

    let chart: any
    let chartSvg: any

    interface GData {
        ikey: string
        key: string
        color: string
        values: any[]
    }
    const gdata: GData[] = [
        { ikey: 'apdex_satisfied', key: 'Satisfait', color: '#2ca02c', values: [] },
        { ikey: 'apdex_tolerated', key: 'Toléré', color: '#1f77b4', values: [] },
        { ikey: 'apdex_frustrated', key: 'Frustré', color: '#ff7f0e', values: [] },
        { ikey: 'failed', key: 'Échoué', color: '#d62728', values: [] },
    ]

    function createChart() {
        for (const gd of gdata) {
            gd.values = []
        }

        // @ts-expect-error
        for (const e of entries) {
            for (const gd of gdata) {
                gd.values.push({
                    x: e.hour,
                    y: e[gd.ikey],
                })
            }
        }

        tick().then(() => {
            nv.addGraph(() => {
                chart = nv.models.stackedAreaChart().id(
                    Math.random()
                        .toString(36)
                        .slice(2, 2 + 15),
                )
                chart.xAxis
                    // .rotateLabels(50)
                    .showMaxMin(false)
                    .axisLabel('Day::Hour')
                    .tickFormat((d: DateTime) => {
                        return toLuxon(d).toFormat('dd::HH')
                    })
                chart.yAxis.showMaxMin(true).axisLabel('Événements')
                // .tickFormat((d: number) => {
                //     return d / 1000
                // })
                chart.margin({
                    top: 20,
                    right: 20,
                    bottom: 50,
                    left: 60,
                })

                chartSvg = d3.select('#chart-nsd-server-events')
                chartSvg.datum(gdata).call(chart)
            })
        })
    }

    let charted = false
    $effect(() => {
        if (!charted && $nvReady && loading == false && entries != null) {
            charted = true
            createChart()
        }
    })
</script>

<style>
    #chart-nsd-server-events {
        height: 250px;
        width: 100%;
    }
</style>

<div class="card">
    <div class="card-title text-primary">Satisfaction</div>
    {#if loading !== false}
        <div class="card-body">
            <LoadingPattern pattern={['x', 'x', 'x', 'x']} />
        </div>
    {:else}
        <div class="card-body">
            <svg id="chart-nsd-server-events" class="nvd3-svg" />
        </div>
    {/if}
</div>
